import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IRichContentDocumentEditorPlaceholder } from '../../models';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const CONTACT_INTEGRATION_CUSTOM_FIELDS_QUERY_KEY = 'contact/integrationCustomFields';
export const useContactIntegrationCustomFieldsQuery = ({
	impersonationContext,
	refetchOnWindowFocus,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	refetchOnWindowFocus?: boolean;
	enabled?: boolean;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IRichContentDocumentEditorPlaceholder[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: CONTACT_INTEGRATION_CUSTOM_FIELDS_QUERY_KEY,
				}),
				'GET'
			);
		},
		queryKey: [CONTACT_INTEGRATION_CUSTOM_FIELDS_QUERY_KEY],
		refetchOnWindowFocus,
	});
};

export const invalidateContactIntegrationFields = () => {
	reactQueryClient.invalidateQueries({ queryKey: [CONTACT_INTEGRATION_CUSTOM_FIELDS_QUERY_KEY] });
};
